import script from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__